export default function Title({ color, icon, title }) {
  const Icon = icon;
  return (
    <div className="title-common">
      <div className="d-flex mt-3 mb-4 ms-4 position-relative">
        <div
          className="rounded-pill d-flex"
          style={{ backgroundColor: ` ${color}`, width: 45, height: 45 }}
        >
          <div
            className="rounded-pill  mx-auto my-auto d-flex align-items-center justify-content-center"
            style={{
              backgroundColor: "white",
              width: 36,
              height: 36,
              // zIndex: 1000,
            }}
          >
            <Icon className="fs-5" color={color} />
          </div>
        </div>
        <div
          className="text-light text-center position-absolute d-flex align-items-center justify-content-center"
          style={{
            backgroundColor: ` ${color}`,
            width: 180,
            height: 28,
            borderTopLeftRadius: 10,
            borderBottomLeftRadius: 10,
            top: 8,
            right: 40,
            padding: 3,
          }}
        >
          {title}{" "}
        </div>
      </div>
    </div>
  );
}
